import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row gy-5 gx-xl-8" }
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = {
  class: "card mb-5 mb-xl-10 h-500px",
  id: "kt_profile_details_view"
}
const _hoisted_4 = { class: "card-header cursor-pointer" }
const _hoisted_5 = { class: "card-title m-0" }
const _hoisted_6 = { class: "fw-bolder m-0" }
const _hoisted_7 = { class: "card-body p-9" }
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_12 = { class: "row mb-7" }
const _hoisted_13 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fw-bold fs-6" }
const _hoisted_16 = { class: "row mb-7" }
const _hoisted_17 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_18 = { class: "col-lg-8 d-flex align-items-center" }
const _hoisted_19 = { class: "fw-bolder fs-6 me-2" }
const _hoisted_20 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_21 = { class: "row mb-7" }
const _hoisted_22 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_23 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_24 = { class: "fw-bold ps-2 fs-6 me-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/svg/avatars/005-girl-2.svg",
  width: "20",
  alt: "image"
}, null, -1)
const _hoisted_26 = {
  key: 1,
  class: "col-lg-8"
}
const _hoisted_27 = { class: "fw-bold ps-2 fs-6 me-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: "media/svg/avatars/009-boy-4.svg",
  width: "20",
  alt: "image"
}, null, -1)
const _hoisted_29 = { class: "row mb-7" }
const _hoisted_30 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_31 = { class: "col-lg-8" }
const _hoisted_32 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_33 = { class: "row mb-7" }
const _hoisted_34 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_35 = { class: "col-lg-8" }
const _hoisted_36 = { class: "fw-bolder fs-6 text-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.t("editProfile.profileDetails")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("editProfile.fullname")), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.student.firstName) + " " + _toDisplayString(_ctx.student.lastName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("editProfile.birthday")), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.moment(_ctx.student.BirthDate).format("l")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t("editProfile.telephoneNumber")), 1),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.student.phone ? _ctx.student.phone : "-"), 1),
              (_ctx.student.phone)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.t("editProfile.verified")), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("editProfile.gender")), 1),
            (_ctx.student.gender == 'female')
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.t("editProfile.girl")), 1),
                  _hoisted_25
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.t("editProfile.boy")), 1),
                  _hoisted_28
                ]))
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("editProfile.address")), 1),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.student.adress ? _ctx.student.adress : "-"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("notes.medicalNote")), 1),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.student.medicalNotes ? _ctx.student.medicalNotes : "-"), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}